<template>
  <div class="bg-gray p-4" id="contractorBlock">
    <div class="row">
      <div class="col-12 col-lg-6 col-xxl-4">
        <ContractorInformationCard />
      </div>
      <div class="col-12 col-lg-6 col-xxl-4 mt-4 mt-lg-0">
        <DispatchersCard class="mh-500px" />
      </div>
      <div class="col-12 col-lg-6 col-xxl-4 mt-4 mt-xxl-0">
        <WorkersCard  class="mh-500px" />
      </div>
    </div>
  </div>
</template>

<script>
import ContractorInformationCard from '@/components/contractors/ContractorInformationCard';
import DispatchersCard from '@/components/contractors/DispatchersCard';
import WorkersCard from '@/components/contractors/WorkersCard';

export default {
  components: {
    ContractorInformationCard,
    DispatchersCard,
    WorkersCard,
  },
};
</script>
